import { Box, Stack } from "@mui/material";
import { blueGrey } from "@mui/material/colors";
import React from "react";
import { Typography } from "@platform/design-system";

const PageNotFound = () => (
  <Stack textAlign={"center"}>
    <Box
      component="p"
      sx={{ fontSize: 120, lineHeight: 1.2, color: blueGrey[400], m: 0 }}
    >
      404
    </Box>
    <Typography variant="display-small">
      Sorry, we couldn&apos;t find that page.
    </Typography>
  </Stack>
);

export default PageNotFound;
